import React, { Component } from 'react';
import { connect } from 'react-redux'
import { updateProject } from '../../../../store/actions/projectActions';
import Loader from 'react-loader-spinner';

import { get } from 'lodash'

class EditProjectForm extends Component {

    constructor(props) {
        super()

        this.state = {
            phone: "",
            email: "",

        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { snagDetail } = this.props;
        const { proid } = snagDetail;
        const { phone, email } = this.state;
        this.props.updateProject(proid, phone, email);
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    componentDidMount() {
        const { snagDetail } = this.props;
        const { phone, email } = snagDetail;

        this.setState({
            phone,
            email,
        });
    }

    render() {
        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: seeing the state of form (do styling adjustments but be cautious with state)
        ///
        const { isProjectUpdating } = this.props.project;
        const textStyle = {
            color: this.props.themeColors.darkThemeColor,
        }
        const relevantSubmitComponent = isProjectUpdating ?
            (<React.Fragment>
                <Loader
                    type="TailSpin"
                    color={this.props.themeColors.themeColor}
                    height={20}
                    width={20}
                />
                <br></br>
                <p style={textStyle}>Updating your project profile...</p>
                <br></br>
            </React.Fragment>)
            :
            (<button className="btn btn-dark btn-sm" style={{ borderRadius: '10px' }} type="submit" >Update info</button>);

        //////////////////////////////////////////////////////////////////////////////////////////////
        /// README: return the form
        ///
        const formLabelStyle = {
            fontSize: "12px",
            fontWeight: "bold",
        };


        const { snagDetail, modalWidth } = this.props;
        const { phone, email } = this.state;

        return (
            <div className="dynamicModalContainer">
                <div className="dynamicModalSm">
                    {/* MAIN FORM */}
                    <form onSubmit={this.handleSubmit}>
                        <div className="form-group text-left">
                            <label htmlFor="inputText" style={formLabelStyle}>Phone number</label>
                            <input type="tel" className="form-control" id="phone" placeholder="Hint: +441234567899" pattern="[+]{1}[0-9]{2,}" onChange={this.handleChange} required defaultValue={phone} />
                        </div>
                        <div className="form-group text-left">
                            <label htmlFor="inputText" style={formLabelStyle}>Email</label>
                            <input type="email" className="form-control" id="email" onChange={this.handleChange} required defaultValue={email} />
                        </div>
                        <br></br>
                        {relevantSubmitComponent}
                    </form>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    // console.log(state.firebase.data.Company)
    return {
        company: state.company,
        themeColors: state.theme,
        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,
        userId: state.firebase.auth.uid,
        modalWidth: state.appControl.modalWidth,

        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateProject: (proid, phone, email) => dispatch(updateProject(proid, phone, email)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditProjectForm);
